import React, { useEffect } from 'react'
import { useField, useFormikContext } from 'formik'
import Switch from 'react-switch'

interface FormikSwitchProps {
    name: string
    label: string
    checkedValue?: any
    uncheckedValue?: any
    checkedLabel?: string
    uncheckedLabel?: string
}

const FormikSwitch: React.FC<FormikSwitchProps> = ({
    name,
    label,
    checkedValue,
    uncheckedValue,
    checkedLabel,
    uncheckedLabel,
}) => {
    const { setFieldValue, values } = useFormikContext<any>()
    const [field, meta] = useField(name)

    const handleChange = (checked: boolean) => {
        const value = checked ? checkedValue : uncheckedValue
        setFieldValue(name, value)
    }

    useEffect(() => {
        if (values[name] === undefined) {
            setFieldValue(name, checkedValue)
        }
    }, [name, setFieldValue, values, checkedValue])

    return (
        <div className="mb-4 flex items-center justify-between">
            <p className="text-gray-1 text-md mb-2">{label}</p>
            <Switch
                onChange={handleChange}
                checked={values[name] === checkedValue}
                onHandleColor="#EAEEF0"
                handleDiameter={24}
                uncheckedIcon={
                    <div className="text-gray-bg mt-1 text-sm text-center">
                        {uncheckedLabel}
                    </div>
                }
                checkedIcon={
                    <div className="text-white text-sm translate-y-1 text-center">
                        {checkedLabel}
                    </div>
                }
                offColor="#B6BCC8"
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                height={30}
                width={70}
                id="material-switch"
                style={{ display: 'none', alignItems: 'center' }}
            />
        </div>
    )
}

export default FormikSwitch
